// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const getHubStatus = async (data) => {
  try {
    const hubStatus = await axios.post(
      "/api/shared/get-hub-status",
      data
    );
    return hubStatus.data;
  } catch (error) {
    console.error("Utils - Get hub satus - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default getHubStatus; 
